module.exports = __webpack_public_path__ + "img/more-vertical.0363eaa4.svg";